import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdCard, faPen } from '@fortawesome/free-solid-svg-icons';
import './ProfileStrip.css';

interface ProfileStripProps {
  summary: React.ReactNode;
  hubPath: string;
  hubLabel: string;
}

const ProfileStrip: React.FC<ProfileStripProps> = ({ summary, hubPath, hubLabel }) => (
  <div className="profile-strip">
    <div className="profile-strip-text">
      <FontAwesomeIcon icon={faIdCard} className="profile-strip-icon" />
      <span>{summary}</span>
    </div>
    <Link to={hubPath} className="profile-strip-link">
      <FontAwesomeIcon icon={faPen} /> Edit on {hubLabel}
    </Link>
  </div>
);

export default ProfileStrip;
